/**
 * Pawsy: carry Whop attribution onto the Shopify order.
 *
 * The Whop pixel identifies a visitor with the _wuid cookie, but Shopify's
 * checkout and thank-you pages do not render our theme layouts, so the pixel
 * never sees the purchase. The purchase is reported server-side from the
 * orders/paid webhook instead -- and that job can only attribute the sale if
 * the visitor's _wuid travelled with the order.
 *
 * Shopify cart attributes survive into order.note_attributes, so that is the
 * carrier. Keys are underscore-prefixed, which Shopify treats as private: they
 * stay off the customer's checkout summary and order confirmation.
 *
 * Click ids are captured on the landing page and kept in sessionStorage,
 * because the visitor has usually navigated away from the ?fbclid= URL by the
 * time they add to cart.
 */
(function () {
  if (window.__pawsyWhopAttr) return;
  window.__pawsyWhopAttr = true;

  var CLICK_KEYS = ['fbclid','gclid','ttclid','msclkid','gbraid','wbraid','li_fat_id','rdt_cid','sccid','twclid'];
  var UTM_KEYS   = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id'];
  var STORE = '_pawsy_attr';

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\/+^]/g, '\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function readStored() {
    try { return JSON.parse(sessionStorage.getItem(STORE) || '{}'); } catch (e) { return {}; }
  }

  // First touch wins: never let a later internal navigation blank out the
  // click id the visitor actually arrived on.
  function collect() {
    var stored = readStored();
    var qs = new URLSearchParams(location.search);
    CLICK_KEYS.concat(UTM_KEYS).forEach(function (k) {
      var v = qs.get(k);
      if (v && !stored[k]) stored[k] = v.slice(0, 200);
    });
    try { sessionStorage.setItem(STORE, JSON.stringify(stored)); } catch (e) {}
    return stored;
  }

  // Capture click ids IMMEDIATELY, before anything can bail out. The Whop
  // pixel's s.js is async, so on a fresh landing hit the _wuid cookie does not
  // exist yet -- and that landing URL is the only page that ever carries
  // ?fbclid=. Gating capture on the cookie threw the click id away on exactly
  // the page that had it, leaving revenue with no ad attached.
  collect();

  function desired() {
    var wuid = cookie('_wuid') || cookie('_wuid_link');
    if (!wuid) return null;                 // identity not minted yet; sync() retries
    var a = { _whop_wuid: wuid };
    var stored = readStored();
    Object.keys(stored).forEach(function (k) { a['_whop_' + k] = stored[k]; });
    if (document.referrer && !a._whop_referrer) a._whop_referrer = document.referrer.slice(0, 200);
    return a;
  }

  function sync() {
    var want = desired();
    if (!want) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var have = (cart && cart.attributes) || {};
        // Only write when something actually differs, so this costs one GET
        // per page load in the steady state rather than a POST every time.
        var stale = Object.keys(want).some(function (k) { return have[k] !== want[k]; });
        if (!stale) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: want })
        });
      })
      .catch(function () { /* attribution is best-effort; never block the store */ });
  }

  // Retry while the pixel mints _wuid. Without this, a visitor who lands and
  // adds to cart quickly gets a cart with no identity on it.
  function syncWithRetry() {
    var tries = 0;
    (function attempt() {
      if (desired()) { sync(); return; }
      if (++tries > 6) return;              // ~8s, then give up quietly
      setTimeout(attempt, tries < 3 ? 500 : 2000);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncWithRetry);
  else syncWithRetry();
  // A cart add mints a new cart when the old one was just checked out.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.pw-atc, .pawsy-satc__btn')) setTimeout(syncWithRetry, 1200);
  }, true);
})();
